// this will be used until typescript upgraded to 4.3+
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Override< Sup >( sup : { prototype : Sup } ) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return <Field extends keyof Sup, Proto extends { [ key in Field ] : Sup[ Field ] }> (proto: Proto, field: Field, descr: TypedPropertyDescriptor<Sup[Field]>) => { /**/ };
}